var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonArw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 2.03224C18.0173 1.48024 17.5842 1.01833 17.0322 1.00052L8.03692 0.710348C7.48492 0.692541 7.02301 1.12559 7.0052 1.67759C6.98739 2.22958 7.42044 2.6915 7.97244 2.70931L15.9683 2.96724L15.7103 10.9631C15.6925 11.5151 16.1256 11.977 16.6776 11.9948C17.2296 12.0126 17.6915 11.5796 17.7093 11.0276L17.9995 2.03224ZM1 17L1.68394 17.7295L17.6839 2.72954L17 2L16.3161 1.27046L0.316059 16.2705L1 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArw);
export default __webpack_public_path__ + "static/media/button-arw.ecb14e4892e28be0e02f62cc58ff79e1.svg";
export { ForwardRef as ReactComponent };